const React = require("react");
const { usePrintify } = require("../context/PrintifyContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, ResourceState, Kpi, StatusBadge } = require("../components/ui");
const h = React.createElement;

const DropshippingAdmin = () => {
  const { api, t, isAdmin } = usePrintify();
  const resource = useResource(async () => ({
    ...(await api.getPlatform()),
    ...(await api.getAdminOverview()),
    ...(await api.getAdminConnections()),
  }), [api]);
  const [busy, setBusy] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  if (!isAdmin) return h("div", { className: "pyds-state" }, t("h_printify_admin_only", "Administration access required."));
  const overview = resource.data?.overview || {};
  const connections = resource.data?.connections || [];
  const platform = resource.data?.platform;
  const action = async (callback, success) => {
    setBusy(true); setMessage(""); setError("");
    try { await callback(); setMessage(success); await resource.reload(); }
    catch (requestError) { setError(requestError.message); }
    finally { setBusy(false); }
  };
  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_printify_admin_title", "Printify administration"),
      action: h("div", { className: "pyds-row" },
        h(Button, { disabled: busy, variant: platform?.status === "active" ? "danger" : "", onClick: () => action(() => api.updateAdminPlatform({ status: platform?.status === "active" ? "inactive" : "active" }), t("h_printify_platform_updated", "Printify platform status updated.")) }, platform?.status === "active" ? t("h_printify_disable", "Disable Printify") : t("h_printify_enable", "Enable Printify")),
        h(Button, { disabled: busy, variant: "secondary", onClick: () => action(api.syncAllSellers, t("h_printify_admin_sync_done", "All active Printify sellers were synchronized.")) }, t("h_printify_sync_all_sellers", "Sync all sellers"))
      ),
    }),
    message ? h("div", { className: "pyds-success" }, message) : null,
    error ? h("div", { className: "pyds-alert" }, error) : null,
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: false, reload: resource.reload, t },
      h(React.Fragment, null,
        h("div", { className: "pyds-kpis" },
          h(Kpi, { value: overview.connections || 0, label: t("h_printify_connections", "Connections") }),
          h(Kpi, { value: overview.products || 0, label: t("h_printify_products", "Products") }),
          h(Kpi, { value: overview.orders || 0, label: t("h_printify_orders", "Orders") }),
          h(Kpi, { value: overview.errors || 0, label: t("h_printify_errors", "Errors") })
        ),
        h("div", { className: "pyds-table-wrap" }, h("table", { className: "pyds-table" },
          h("thead", null, h("tr", null, h("th", null, t("h_printify_seller", "Seller")), h("th", null, t("h_printify_store", "Store")), h("th", null, t("h_printify_status", "Status")), h("th", null, ""))),
          h("tbody", null, ...connections.map((connection) => h("tr", { key: connection._id },
            h("td", null, connection.sellerId?.email || connection.sellerId?._id),
            h("td", null, connection.shopName || connection.shopId || "—"),
            h("td", null, h(StatusBadge, { status: connection.status, t })),
            h("td", null, connection.status !== "inactive" ? h(Button, { variant: "danger", disabled: busy, onClick: () => action(() => api.disableConnection(connection._id), t("h_printify_connection_disabled", "Printify connection disabled.")) }, t("h_printify_disable_connection", "Disable")) : null)
          )))
        ))
      )
    )
  );
};

module.exports = { DropshippingAdmin };
